import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 16, viewBox: "0 0 9 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.51471 14.0711C8.51471 14.962 7.43757 15.4081 6.8076 14.7782L0.736529 8.7071C0.346004 8.31658 0.346005 7.68342 0.736529 7.29289L6.8076 1.22183C7.43757 0.591867 8.51471 1.03803 8.51471 1.92894L8.51471 14.0711Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconArrow);
export default ForwardRef;
